<template>
    <div>
        <div v-if="list.length==0 && finished" class="noImgBox">
            <img class="noImg" :src="src" alt="">
            <span>暂无产品哦~</span>
        </div>
        <van-list class='listItems'
            v-else
            :v-model="loading"
            :finished="finished"
            finished-text="没有更多了"
            @load="onload"
            >
            <van-cell v-for="(item,index) in list" :key="index">
                <cell-list :productInfo="item"></cell-list>
            </van-cell>
        </van-list>
    </div>
    
    
</template>

<script>
import cellList from "@/components/cellList2"
export default {
    props:["category"],
    data() {
        return {
            src:require("@/assets/imgs/meiyoushoucang.png"),
            is_down:0,
            is_report:"",//默认空，0:未报备(备案中)，1:已报备
            list:[],
            finished:false,
            loading:false,
            page:1,
            timer:null
        };
    },
    methods:{
        onload(){
            if(!this.timer){
                this.timer = setTimeout(() => {
                    this.getList()       //请求列表数据的方法
                    this.timer = null;
                }, 200)
            }
        },
        getList(){
            let is_down=this.category.key=="is_down"?1:0
            let category_id=this.category.key=='is_down'?0:this.category.key
            let is_report=this.category.key=="is_report"?0:1
            //  console.log("this.category_id",this.category_id,this.is_down)
                this.$https.fetchPost("Goods/index",{"page":this.page,"is_hot":"","category_id":category_id,"is_down":is_down,"is_report":is_report},{headers:{"XX-Token":this.$store.state.token}})
                .then(result=>{
                    let data=result.data;
                    // console.log(data)
                    if(data.code==1 && data.data.length!=0){
                        this.list=[...this.list,...result.data.data];
                        this.loading= false;
                        this.page++;
                    }else{
                        this.finished= true;
                    }
                })
        },
        pull(){
            console.log("下拉上一页")
        }
    },
    components:{
        cellList,
    },
}
</script>

<style scoped>
  .van-cell{
      padding:0;
  }
    .noImgBox{
        margin-top: 200px;
        display: flex;
        flex-direction: column;
        align-items: center;
  }
  .noImgBox span{
      color:#666;
      font-size:12px;
      margin-top:5px;

  }
  .noImg{
      width: 60px;
  }
  
</style>


// WEBPACK FOOTER //
// src/components/productListItem.vue